import * as AppPics from 'assets/images';

function Html() {
  return (
    <div className="mainWraper">
      <div className="tab">
        <ul className="tab__menu">
          <li className="back">
            <button className="btn-back">
              <img src={AppPics.BackSvg} alt="" />
            </button>
          </li>
          <li>Notes</li>
          <li>Videos</li>
          <li className="active">Stories</li>
          <li className="">Sprint</li>
          <li className="">Mind Tree</li>
          <li className="">Geek Corner</li>
          <li className="">Echoes</li>
        </ul>
        <div className="tab__content">
          <div className="container">
            <div className="row">
              <div className="col-12">
                <h2 className="prime-head p-0 boldtitle">Test Sub Lesson1</h2>
                <span className="boldtitle mt-5 conaddtitle">Add New Story</span>
              </div>
            </div>

            <div className="row">
              <div className="col-lg-5 col-md-6 col-sm-12">
                <div className="w-100 mt-4">
                  <label htmlFor="">Story Title</label>
                  <input type="text" placeholder="Enter" />
                </div>
                <div className="w-100 mt-4">
                  <label htmlFor="">Story Description</label>
                  <textarea name="" id="" cols="20"></textarea>
                </div>
                <div className="w-100 mt-4 ">
                  <label htmlFor="">Story Search Tags</label>
                  <textarea name="" id="" cols="20"></textarea>
                </div>
              </div>

              <div className="col-lg-5 col-md-6  col-sm-12  ">
                <div className="w-100 mt-4">
                  <label htmlFor="">Choose Story Pages from this Local Machine (.PNG Format)</label>
                  <div className="d-flex align-items-center">
                    <span className="radioBlock">
                      <input id="test1" name="test" value="1" type="radio" />
                      <label htmlFor="test1">Page 1</label>
                    </span>
                  </div>
                  <div className="d-flex align-items-center">
                    <span className="radioBlock">
                      <input id="test2" name="test" value="2" type="radio" />
                      <label htmlFor="test2">Page 2</label>
                    </span>
                  </div>
                  <div className="d-flex align-items-center">
                    <span className="radioBlock">
                      <input id="test3" name="test" value="3" type="radio" />
                      <label htmlFor="test3">Page 3</label>
                    </span>
                  </div>
                  <div className="d-flex align-items-center">
                    <span className="radioBlock">
                      <input id="test4" name="test" value="4" type="radio" />
                      <label htmlFor="test4">Page 4</label>
                    </span>
                  </div>
                  <div className="d-flex align-items-center">
                    <span className="radioBlock">
                      <input id="test5" name="test" value="5" type="radio" />
                      <label htmlFor="test5">Page 5</label>
                    </span>
                  </div>
                  <div className="d-flex align-items-center">
                    <span className="radioBlock">
                      <input id="test6" name="test" value="6" type="radio" />
                      <label htmlFor="test6">Page 6</label>
                    </span>
                  </div>
                  <button className="btn-right-content upload">Upload</button>
                </div>
              </div>
            </div>
            <div className="row mt-5 btnsubmitmain">
              <div className="col-12 btnTab-foot">
                <button className="btn-right-content save">Save Changes</button>
              </div>
            </div>

            <div className="row">
              <div className="col-12">
                <span className=" col-12  mt-5 mb-5 conaddtitle boldtitle">Uploaded Stories</span>

                <div className="storyouter">
                  <img className="sliderSec-boxImg" src="https://picsum.photos/300/400" alt="" />
                  <label className="storytitlename">
                    Story Title
                    <span className="mx-3">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="14.902"
                        height="14.902"
                        viewBox="0 0 14.902 14.902"
                      >
                        <g
                          id="Icon_feather-edit"
                          data-name="Icon feather-edit"
                          transform="translate(-2 -1.818)"
                        >
                          <path
                            id="Path_9214"
                            data-name="Path 9214"
                            d="M8.771,6H4.282A1.282,1.282,0,0,0,3,7.282V16.26a1.282,1.282,0,0,0,1.282,1.282H13.26a1.282,1.282,0,0,0,1.282-1.282V11.771"
                            transform="translate(0 -1.822)"
                            fill="none"
                            stroke="#7e1f8c"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                          />
                          <path
                            id="Path_9215"
                            data-name="Path 9215"
                            d="M18.733,3.216A1.36,1.36,0,1,1,20.657,5.14l-6.092,6.092L12,11.873l.641-2.565Z"
                            transform="translate(-5.153)"
                            fill="none"
                            stroke="#7e1f8c"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                          />
                        </g>
                      </svg>
                    </span>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Html;
